export enum TableType {
    Campaign = "campaignTable",
    Donor = "donorTable",
    Gift = "giftTable",
    RecurringGift = "recurringGiftTable",
    Project = "projectTable",
    Segment = "segmentTable",
}